import { CLEAR_PRODUCTS, GET_ALL_PRODUCTS_BEGIN, GET_ALL_PRODUCTS_FAILURE, GET_ALL_PRODUCTS_SUCCESS, POST_CREATE_PRODUCT_BEGIN, POST_CREATE_PRODUCT_FAILURE, POST_CREATE_PRODUCT_SUCCESS } from './../constants/ActionTypes'
  
  const initialState = {
    products: null,
    productsError: null,
    loadingProducts: false,
  
    createdProduct: null,
    createProductError: null,
    creatingProduct: false
  }
  
  const ReducerProduct = (state = initialState, { payload, type }) => {
    switch (type) {
      case GET_ALL_PRODUCTS_BEGIN: {
        return {
          ...state,
          loadingProducts: true,
          productsError: null,
          products: null
        }
      }
      case GET_ALL_PRODUCTS_SUCCESS: {
        return {
          ...state,
          loadingProducts: false,
          productsError: null,
          products: payload.response
        }
      }
      case GET_ALL_PRODUCTS_FAILURE: {
        return {
          ...state,
          loadingProducts: false,
          productsError: payload,
          products: null
        }
      }
  
      case POST_CREATE_PRODUCT_BEGIN: {
        return {
          ...state,
          createdProduct: null,
          createProductError: null,
          creatingProduct: true
        }
      }
      case POST_CREATE_PRODUCT_SUCCESS: {
        return {
          ...state,
          createdProduct: payload.response,
          createProductError: null,
          creatingProduct: false
        }
      }
      case POST_CREATE_PRODUCT_FAILURE: {
        return {
          ...state,
          createdProduct: null,
          createProductError: payload,
          creatingProduct: false
        }
      }
  
      case CLEAR_PRODUCTS: {
        return initialState
      }
  
      default: return state
    }
  }
  
  export default ReducerProduct